import React from "react";
import { v4 as uuid } from "uuid";
import { isMediumDeviceWidth, isSmallDeviceWidth } from "component-library";
import { IMakeSuggestionsPerformer } from "models/suggestion";
import withPagination, { IWithPaginationProps } from "hoc/withPagination";
import { IMakeSuggestionsGridTexts } from "components/SuggestionsViewAgent/SuggestionsViewAgent.helpers";

import Card from "../Card/Card";
import { SkeletonCard } from "../SkeletonCard/SkeletonCard";

import "./MakeSuggestionsGrid.scss";

export const SKELETONS_COUNT_LARGE = 6;
export const SKELETONS_COUNT_MEDIUM = 4;
export const SKELETONS_COUNT_SMALL = 1;

export interface IMakeSuggestionsGridProps extends IWithPaginationProps {
  performers: IMakeSuggestionsPerformer[];
  suggestedPerformers: IMakeSuggestionsPerformer[];
  texts: IMakeSuggestionsGridTexts;
  onSelectChange: (item: IMakeSuggestionsPerformer, value: boolean) => void;
  onCommentChange: (item: IMakeSuggestionsPerformer, value: string) => void;
  onPhotoSelect: (item: IMakeSuggestionsPerformer, value: string) => void;
  isLoading: boolean;
  wrapperWidth: number;
}

class MakeSuggestionsGrid extends React.PureComponent<IMakeSuggestionsGridProps> {
  public render() {
    const { isLoading } = this.props;

    return (
      <div className="c-make-suggestions-grid">
        <div>{this.renderTopBar()}</div>
        <div className="c-make-suggestions-grid__inner g-bg-default g-col-lg-12 g-inner-grid">
          {isLoading ? this.renderSkeletonCards() : this.renderCards()}
        </div>
        {this.renderBottomBar()}
      </div>
    );
  }

  public renderTopBar() {
    const { renderPaginationResultStats, renderPagination } = this.props;

    return (
      <div className="c-jobs-table__top-bar">
        <div className="c-jobs-table__count-info">
          {renderPaginationResultStats()}
        </div>
        <div className="c-jobs-table__pagination">{renderPagination()}</div>
      </div>
    );
  }

  public renderBottomBar() {
    const { renderPagination } = this.props;

    return (
      <div className="c-jobs-table__bottom-bar">
        <div className="c-jobs-table__pagination">{renderPagination(true)}</div>
      </div>
    );
  }

  private renderCards = () => {
    const {
      onCommentChange,
      onPhotoSelect,
      onSelectChange,
      performers,
      suggestedPerformers,
      texts: {
        voiceClipsTooltip,
        videoShowreelTooltip,
        membershipTypes,
        addComment,
        performerAge,
        morePhotos,
        membershipExpires,
        clientNudged,
        clientSubmittedThemselves,
      },
      wrapperWidth,
    } = this.props;

    return performers.map((performer) => {
      const suggestedPerformer = suggestedPerformers.find(
        (item) => item.artistRef === performer.artistRef
      );

      return (
        <Card
          texts={{
            voiceClipsTooltip,
            videoShowreelTooltip,
            membershipTypes,
            performerAge,
            morePhotos,
            membershipExpires,
            addComment,
            clientNudged,
            clientSubmittedThemselves,
          }}
          performer={
            suggestedPerformer ?? { ...performer, suggestion: undefined }
          }
          key={performer.artistRef + performer.agency.id}
          onSelectChange={onSelectChange}
          onCommentChange={onCommentChange}
          onPhotoSelect={onPhotoSelect}
          wrapperWidth={wrapperWidth}
        />
      );
    });
  };

  private renderSkeletonCards = () => {
    const skeletonCount = isSmallDeviceWidth()
      ? SKELETONS_COUNT_SMALL
      : isMediumDeviceWidth()
      ? SKELETONS_COUNT_MEDIUM
      : SKELETONS_COUNT_LARGE;

    return Array(skeletonCount)
      .fill(1)
      .map(() => <SkeletonCard key={uuid()} />);
  };
}

export default withPagination<IMakeSuggestionsGridProps>(MakeSuggestionsGrid);
